// extracted by mini-css-extract-plugin
module.exports = {"navLogo":"NavLogo_navLogo__zsN23","navLogoSmall":"NavLogo_navLogoSmall__m3n4d"};